import { memo } from 'react';
import { type Control, Controller, type UseFormGetValues, type UseFormSetValue } from 'react-hook-form';
import type { ClientRole } from '@/api/roles-and-permission';
import Checkbox from '@/components/UI/Form/Checkbox';
import { getTabPermissions, type PrevilegesForm, type TProductGroupType } from '@/features/Settings/RolesAndPermission/utils';

type SelectAllProps = {
  currentNav: TProductGroupType;
  role: ClientRole;
  allChecked: PrevilegesForm;
  allUnchecked: PrevilegesForm;
  control: Control<PrevilegesForm>;
  getValues: UseFormGetValues<PrevilegesForm>;
  setValue: UseFormSetValue<PrevilegesForm>;
};

export const SelectAll = memo(({ currentNav, role, allChecked, allUnchecked, control, getValues, setValue }: SelectAllProps) => {
  const toggleSelectAll = (checked: boolean) => {
    const allPermissions = getValues();
    const currentRolePermissions = allPermissions[role.slug];

    const allCheckboxState = {
      ...currentRolePermissions.all,
      [currentNav]: checked,
    };

    const changedPermissions = getTabPermissions(currentNav, checked ? allChecked[role.slug] : allUnchecked[role.slug]);

    setValue(
      role.slug,
      {
        ...allPermissions[role.slug],
        ...changedPermissions,
        all: allCheckboxState,
      },
      {
        shouldDirty: true,
        shouldTouch: true,
      }
    );
  };

  return (
    <th className='text-center px-0 py-1 sticky top-0 bg-gray-100 border-t z-20'>
      <div className='flex justify-center'>
        <Controller
          name={`${role.slug}.all.${currentNav}`}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <>
              <Checkbox
                inputClassName='-mr-2'
                onChange={(e) => {
                  toggleSelectAll(e.target.checked);
                  field.onChange(e);
                }}
                checked={field.value}
                error={error?.message}
              />
            </>
          )}
        />
      </div>
    </th>
  );
});
